import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useFORM_REPLIES_COUNTER_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'FORM_REPLIES_COUNTER',
    name: t('widgets.formRepliesCounter.name'),
    description: t('widgets.formRepliesCounter.description'),
    color: 'blue',
    icon: 'RiTimerLine',
    categories: [t('widgets.formRepliesCounter.category')],
    previewWidth: '45%',

    initialState: {
      name: t('widgets.formRepliesCounter.initialStateName'),
      size: { width: 25, height: 175 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
